import Axios from "../../initializers/axios"
import { handleErrorResponse } from "helpers/errorHandling"
import { digestApi, eventsApi, rsvpApi } from "../api"
import { PUBLIC_FLAG_URL, EVENT_URL } from "constants/constants"
import { EventCreateRequest, EventUpdateRequest, Event } from "suus-api"
import { parseAxiosError } from "features/common/errors/parseAxiosError"

export default {
  setFormData({ commit }: any) {
    commit("setCurrEventToFormData")
  },
  async getEvent({ state, commit }: any, event_id: string): Promise<Event> {
    if (event_id && state.events && state.events[event_id]) {
      const currentEvent = state.events[event_id]
      commit("SET_EVENT_DATA", currentEvent)
      return currentEvent
    }
    try {
      commit("SET_EVENT_ERROR", false)
      commit("SET_EVENT_LOADING", true)
      const { data: event } = await eventsApi.getEvent(event_id)
      commit("SET_EVENT_DATA", event)
      commit("ADD_EVENTS", event)
      if (event.is_public) {
        commit("ADD_PUBLIC", event_id)
      }
      return event
    } catch (error) {
      commit("SET_EVENT_ERROR", error)
      handleErrorResponse(error)
      throw error
    } finally {
      commit("SET_EVENT_LOADING", false)
    }
  },
  async createEvent(
    { state, commit }: any,
    request_body: EventCreateRequest
  ): Promise<Event | null> {
    try {
      const { data: event } = await eventsApi.createEvent(request_body)
      commit("SET_EVENT_DATA", event)
      commit("ADD_EVENTS", event)
      return event
    } catch (error: any) {
      let errorMessage = "Failed to create event"
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = parseAxiosError(error.response)
      } else {
        throw error
      }
      handleErrorResponse(error)
      throw new Error(errorMessage)
    }
  },
  async updateEvent(
    { state, commit }: any,
    {
      event_id,
      request_body,
    }: { event_id: string; request_body: EventUpdateRequest }
  ) {
    try {
      const { data: event } = await eventsApi.updateEvent(
        event_id,
        request_body
      )
      commit("SET_EVENT_DATA", event)
      commit("UPDATE_EVENTS", event)
    } catch (error: any) {
      let errorMessage = "Failed to update event"
      if (
        error.response &&
        error.response.data.error &&
        error.response.data.message
      ) {
        errorMessage = parseAxiosError(error.response)
      } else {
        throw error
      }
      handleErrorResponse(error)
      throw new Error(errorMessage)
    }
  },
  async deleteEvent({ state, commit }: any, event_id: string) {
    try {
      commit("SET_EVENT_ERROR", false)
      await eventsApi.deleteEvent(event_id)
      commit("DELETE_EVENT", event_id)
      commit("SET_EVENT_DATA", {})
      commit("setCurrEventToFormData")
    } catch (error) {
      commit("SET_EVENT_ERROR", error)
      handleErrorResponse(error)
      throw error
    }
  },
  async getEventFromDigest({ state, commit }: any, event_id: string) {
    if (event_id && state.events && state.events[event_id]) {
      const currentEvent = state.events[event_id]
      commit("SET_EVENT_DATA", currentEvent)
    }
    try {
      commit("SET_EVENT_ERROR", false)
      commit("SET_EVENT_LOADING", true)
      const { data: event } = await digestApi.getDigestEvent(event_id)
      commit("SET_EVENT_DATA", event)
      commit("ADD_EVENTS", event)
    } catch (error) {
      commit("SET_EVENT_ERROR", error)
      handleErrorResponse(error)
      throw error
    } finally {
      commit("SET_EVENT_LOADING", false)
    }
  },
  async addPublic({ state, commit }: any, event_id: string) {
    try {
      const url = `${EVENT_URL}${event_id}${PUBLIC_FLAG_URL}`
      const { data } = await Axios.post(url)
      commit("UPDATE_EVENT_ATTRIBUTE", { key: "is_public", val: true })
      commit("UPDATE_EVENTS", state.currentEvent.data)
    } catch (error) {
      handleErrorResponse(error)
    }
  },
  async deletePublic({ state, commit }: any, event_id: string) {
    try {
      const url = `${EVENT_URL}${event_id}${PUBLIC_FLAG_URL}`
      const { data } = await Axios.delete(url)
      commit("UPDATE_EVENT_ATTRIBUTE", { key: "is_public", val: false })
      commit("UPDATE_EVENTS", state.currentEvent.data)
    } catch (error) {
      handleErrorResponse(error)
    }
  },
}
